export const FETCHED_ALL = "books/fetchedAll";
export const ADDED = "books/added";
export const UPDATED = "books/updated";
export const LOADED_FORM_DATA = "books/loadedFormData";
export const DELETED = "books/deleted";
export const FILTERED = "books/filtered";
